module.exports = __webpack_public_path__ + "img/ObenImSchachtFuesseUntenTransp.212e8774.png";